<template>
  <v-container>
    <v-flex mb-4 xs12>
      <h4 class="headline">完成維修</h4>
    </v-flex>
    <v-flex xs12 mb-4>
      <image-uploader
        :debug="1"
        :maxWidth="512"
        :quality="0.7"
        :autoRotate="true"
        outputFormat="string"
        :preview="true"
        :className="[' file-button', { 'fileinput--loaded': hasImage }]"
        accept="image/*"
        doNotResize="['gif', 'svg']"
        @input="setImage"
      ></image-uploader>
    </v-flex>
    <VueSignaturePad
      id="signature"
      width="100%"
      height="300px"
      ref="signaturePad"
    />
    <v-flex xs12 class="d-flex mt-6">
      <v-btn outlined color="blue-grey" to="/">取消</v-btn>
      <v-btn class="ml-auto" outlined color="blue-grey " @click="undo"
        >重新簽名</v-btn
      >
      <v-btn
        @click="onConfirm"
        depressed
        class="ml-2"
        color="blue-grey white--text"
        >簽收</v-btn
      >
    </v-flex>
    <v-row mt-5 v-if="loading">
      <v-col class="d-flex justify-end">
        <v-progress-circular
          indeterminate
          color="blue-grey"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection } from "@/db";
import firebase from "firebase";
export default {
  name: "FinishRepair",
  data: () => ({
    loading: false,
    signature_base64: "",
    hasImage: false,
    signatureImg: {
      image: "",
      imgType: ""
    }
  }),
  methods: {
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    setImage: function(output) {
      this.hasImage = true;
      this.signatureImg.image = output;
      this.signatureImg.imgType = output.substring(
        5,
        output.indexOf(";base64")
      );
    },
    onConfirm() {
      this.loading = true;
      this.signature_base64 = this.$refs.signaturePad.saveSignature().data;
      const signatureImgType = this.signature_base64.substring(
        5,
        this.signature_base64.indexOf(";base64")
      );

      const imgArr = [
        {
          image: this.signatureImg.image,
          imageType: this.signatureImg.imgType,
          name: "finished"
        },
        {
          image: this.signature_base64.replace(
            `data:${signatureImgType};base64,`,
            ""
          ),
          imageType: signatureImgType,
          name: "signature"
        }
      ];
      Promise.all(
        imgArr.map(
          async (image, index) => await this.putStorageItem(image, index)
        )
      )
        .then(data => {
          repairsCollection
            .doc(this.$route.params.repair_id)
            .update({
              ...{
                finishedDate: new Date(),
                completed: true,
                finishedImage: data[0].downloadURL,
                signatureImage: data[1].downloadURL,
                finishedCurrentUser: firebase.auth().currentUser.email
              }
            })
            // eslint-disable-next-line no-unused-vars
            .then(docRef => {
              this.$router.push("/");
            })
            // eslint-disable-next-line no-console
            .catch(error => console.log(error));
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(`Some failed: `, error);
        });
    },
    // eslint-disable-next-line no-unused-vars
    putStorageItem(data, index) {
      // the return value will be a Promise
      const { image, imageType, name } = data;
      const storageRef = firebase
        .storage()
        .ref(`/${this.$route.params.repair_id}/`);
      const file = image.replace(`data:${imageType};base64,`, "");
      // 20190318
      const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      const fileName = `${
        this.$route.params.repair_id
      }_${currentDate}_${Math.floor(Math.random() * 90000) + 10000}_${name}`;
      return new Promise((resolve, reject) => {
        storageRef
          .child(fileName)
          .putString(file, "base64", { contentType: imageType })
          .then(snapshot => {
            snapshot.ref.getDownloadURL().then(function(downloadURL) {
              const data = { name, downloadURL };
              resolve(data);
            });
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log("One failed:", error);
            // eslint-disable-next-line no-undef
            reject(err);
          });
      });
    }
  }
};
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>
